import { Accordion, AccordionItem, Divider } from '@heroui/react';
import { useTranslations } from 'next-intl';
import React from 'react';
import PriceBreakdown from './price-breakdown';
import Image from 'next/image';
import useOfferComparisonStore from '@/app/store/use-offer-comparison-store';

export default function PriceInfoAccordion() {
  const t = useTranslations('priceInfo');
  const tariffName = useOfferComparisonStore(
    (state) => state.offer?.tariffName
  );

  const accordionItems = [
    {
      title: tariffName,
      startContent: t('tariffName'),
      labelTestId: 'energyCalculatorIndividualOfferTariffName',
      valueTestId: 'energyCalculatorIndividualOfferTariffValue',
    },
    {
      title: t('maxEnergy'),
      startContent: t('supportedBy'),
      labelTestId: 'energyCalculatorIndividualOfferBrandName',
      valueTestId: 'energyCalculatorIndividualOfferBrandValue',
    },
    {
      title: t('contractAmount'),
      startContent: t('contractTitle'),
      content: t('contractInfo'),
    },
    {
      title: t('guaranteeDuration'),
      startContent: t('guaranteeTitle'),
      content: t('guaranteeInfo'),
    },
  ];
  return (
    <div>
      <Accordion className="!px-0" data-testid="costDetailsAccordion">
        <AccordionItem
          indicator={
            <Image
              data-testid="costDetailsDownArrow"
              src="/images/down-arrow.svg"
              alt="down arrow"
              height={7.41}
              width={12}
              className="transition-transform"
            />
          }
          title={<p data-testid="costDetailsTitle">{t('costDetailsTitle')}</p>}
          aria-label={t('costDetailsTitle')}
          classNames={{ indicator: 'data-[open=true]:-rotate-180' }}
        >
          <p data-testid="cost-details-body">{t('costDetailsInfo')}</p>
        </AccordionItem>
      </Accordion>
      <PriceBreakdown />
      <Accordion className="!px-0">
        {accordionItems.map((item) => (
          <AccordionItem
            indicator={
              <Image
                data-testid={`${item.startContent}-trigger`}
                src="/images/down-arrow.svg"
                alt="down arrow"
                height={7.41}
                width={12}
                className="transition-transform"
              />
            }
            key={item.title}
            startContent={
              <p data-testid={item.labelTestId ?? `${item.startContent}-title`}>
                {item.startContent}
              </p>
            }
            title={
              <span data-testid={item.valueTestId ?? `${item.title}-subtitle`}>
                {item.title}
              </span>
            }
            aria-label={item.startContent}
            hideIndicator={!item.content}
            isDisabled={!item.content}
            classNames={{
              startContent: 'basis-2/5 text-start',
              base: '!text-black !opacity-100',
              indicator: 'data-[open=true]:-rotate-180',
            }}
          >
            <p data-testid={`${item.startContent}-body`}>{item.content}</p>
          </AccordionItem>
        ))}
      </Accordion>
      <Divider />
    </div>
  );
}
